<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        config: {
          quickLinks: []
        },
        preferredLanguages: [
          { value: null, text: this.$t('notSet') },
          { value: 'nb', text: this.$t('preferredLanguages.nb') },
          { value: 'nn', text: this.$t('preferredLanguages.nn') }
        ],
        sites: [
          { value: 'AUNIVERS', text: this.$t('sites.AUNIVERS') },
          { value: 'MODUS', text: this.$t('sites.MODUS') },
          { value: 'KUNNE', text: this.$t('sites.KUNNE') },
          { value: 'JURIDIKA', text: this.$t('sites.JURIDIKA') },
          { value: 'LOKUS', text: this.$t('sites.LOKUS') },
          { value: 'UNIBOK', text: this.$t('sites.UNIBOK') },
          { value: 'GAN', text: this.$t('sites.GAN') },
          { value: 'BRETTBOKA', text: this.$t('sites.BRETTBOKA') },
          { value: 'UNSPECIFIED', text: this.$t('sites.UNSPECIFIED') }
        ],
        productTypes: [
          { value: 'COMMON', text: this.$t('productTypes.COMMON') },
          { value: 'TEACHER', text: this.$t('productTypes.TEACHER') },
          { value: 'TEACHER_GUIDE', text: this.$t('productTypes.TEACHER_GUIDE') },
          { value: 'STUDENT', text: this.$t('productTypes.STUDENT') },
          { value: 'BOOK', text: this.$t('productTypes.BOOK')},
        ],
        productSource: [
          { value: 'LOKUS_MAGENTO', text: this.$t('productSources.LOKUS_MAGENTO') },
          { value: 'ACO_BIBLIO', text: this.$t('productSources.ACO_BIBLIO') },
          { value: 'LOCAL', text: this.$t('productSources.LOCAL') }
        ],
        productForm: [
          { value: 'DIGITAL', text: this.$t('productForms.DIGITAL') },
          { value: 'BOOK', text: this.$t('productForms.BOOK') },
          { value: 'PAPER', text: this.$t('productForms.PAPER') },
        ],
        componentType: [
          { value: 'arbeidsbok', text: this.$t('componentTypes.arbeidsbok') },
          { value: 'digitalbok', text: this.$t('componentTypes.digitalbok') },
          { value: 'elevnettsted', text: this.$t('componentTypes.elevnettsted') },
          { value: 'fasit', text: this.$t('componentTypes.fasit') },
          { value: 'lærebok', text: this.$t('componentTypes.lærebok') },
          { value: 'lærernettsted', text: this.$t('componentTypes.lærernettsted') },
          { value: 'lærerveiledning', text: this.$t('componentTypes.lærerveiledning') },
          { value: 'læringsunivers', text: this.$t('componentTypes.læringsunivers') },
          { value: 'lesehefte', text: this.$t('componentTypes.lesehefte') },
          { value: 'nettsted', text: this.$t('componentTypes.nettsted') },
          { value: 'provelisens', text: this.$t('componentTypes.provelisens') },
          { value: 'tilleggsmateriell', text: this.$t('componentTypes.tilleggsmateriell') },
        ],
        licenseTypes: [
          { value: 'USAGE_RIGHTS_UNLIMITED', text: this.$t('licenseTypes.USAGE_RIGHTS_UNLIMITED') },
          { value: 'USAGE_RIGHTS_UNENFORCED', text: this.$t('licenseTypes.USAGE_RIGHTS_UNENFORCED') },
          { value: 'USAGE_RIGHTS_ENFORCED', text: this.$t('licenseTypes.USAGE_RIGHTS_ENFORCED') },
          { value: 'UNSPECIFIED', text: this.$t('licenseTypes.UNSPECIFIED') }
        ],
        licenseOwnershipTypes: [
          { value: 'ALL', text: this.$t('licenseOwnershipTypes.ALL') },
          { value: 'ORGANIZATION', text: this.$t('licenseOwnershipTypes.ORGANIZATION') },
          { value: 'PRIVATE', text: this.$t('licenseOwnershipTypes.PRIVATE') }
        ],
        licenseStatuses: [
          { value: 'ACTIVE', text: this.$t('licenseStatuses.ACTIVE') },
          { value: 'CANCELLED', text: this.$t('licenseStatuses.CANCELLED') }
        ],
        languages: [
          { value: 'nb', text: this.$t('languages.nb') },
          { value: 'nn', text: this.$t('languages.nn') }
        ],
        licenseDurations: [
          { value: 'P13M', text: this.$t('licenseDurations.P13M') },
          { value: 'P25M', text: this.$t('licenseDurations.P25M') },
          { value: 'P37M', text: this.$t('licenseDurations.P37M') }
        ],
        userPrimaryRoles: [
          { value: 'teacher', text: this.$t('userPrimaryRoles.TEACHER') },
          { value: 'student', text: this.$t('userPrimaryRoles.STUDENT') }
        ],
        userAdditionalRoles: [
          { value: 'test_user', text: this.$t('userAdditionalRoles.TEST_USER')},
          { value: 'internal_user', text: this.$t('userAdditionalRoles.INTERNAL_USER')},
          { value: 'writer', text: this.$t('userAdditionalRoles.WRITER')},
          { value: 'contributor', text: this.$t('userAdditionalRoles.CONTRIBUTOR')},
          { value: 'shared_user', text: this.$t('userAdditionalRoles.SHARED_USER')}
        ],
        userSources: [
          { value: 'FEIDE', text: this.$t('userSources.FEIDE') },
          { value: 'LOCAL', text: this.$t('userSources.LOCAL') },
          { value: 'VIPPS', text: this.$t('userSources.VIPPS') },
          { value: 'COGNITO', text: this.$t('userSources.COGNITO') },
          { value: 'AZURE', text: this.$t('userSources.AZURE') }
        ],
        groupSources: [
          { value: 'LOCAL', text: this.$t('groupSources.LOCAL') },
          { value: 'FEIDE', text: this.$t('groupSources.FEIDE') }
        ],
        groupTypes: [
          { value: 'BASIS_CLASS', text: this.$t('groupTypes.BASIS_CLASS') },
          { value: 'TEACHING_GROUP', text: this.$t('groupTypes.TEACHING_GROUP') },
          { value: 'OTHER', text: this.$t('groupTypes.OTHER') },
          { value: 'AD_HOC', text: this.$t('groupTypes.AD_HOC') }
        ],
        eanPrefixes: [
          { value: '200', text: this.$t('eanPrefixes.200') },
          { value: '210', text: this.$t('eanPrefixes.210') },
          { value: '220', text: this.$t('eanPrefixes.220') }
        ],
        licenseModels: [
          { value: 'PRIVATE', text: this.$t('licenseModels.PRIVATE') },
          { value: 'SCHOOL', text: this.$t('licenseModels.SCHOOL') },
          { value: 'INDIVIDUAL', text: this.$t('licenseModels.INDIVIDUAL') },
          { value: 'OPEN', text: this.$t('licenseModels.OPEN') },
          { value: 'TRIAL_SCHOOL', text: this.$t('licenseModels.TRIAL_SCHOOL') },
          { value: 'ORGANIZATIONAL', text: this.$t('licenseModels.ORGANIZATIONAL') }
        ],
        orderSources: [
          { value: 'BOKBASEN', text: this.$t('orderSources.BOKBASEN') },
          { value: 'ECOM_SKOLE', text: this.$t('orderSources.ECOM_SKOLE') },
          { value: 'ECOM_KUNNE', text: this.$t('orderSources.ECOM_KUNNE') },
          { value: 'ECOM_JURIDIKA', text: this.$t('orderSources.ECOM_JURIDIKA') },
          { value: 'ACO_MAGENTO', text: this.$t('orderSources.ACO_MAGENTO') },
        ],
        organizationSources: [
          { value: 'NSR', text: this.$t('organizationSources.NSR')},
          { value: 'LOCAL', text: this.$t('organizationSources.LOCAL')}
        ]
      }
    },
    created: function () {
      switch(process.env.VUE_APP_ENVIRONMENT) {
        case 'production':
          this.config = require('../config/production.json');
          break;
        default:
          this.config = require('../config/default.json')
      }
    },

    methods: {
      async downloadFile (url, filename) {
        console.log('Downloading ' + url + ' to ' + filename)

        await axios({
          url: url,
          method: 'GET',
          responseType: 'blob',
        }).then((response) => {
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(new Blob([response.data]))
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
      },
      formatTimestamp (timestamp) {
        if (!timestamp) {
          return null
        }
        let dateObj = new Date(timestamp)
        return dateObj.toLocaleDateString('nb-NO') + ' ' + dateObj.toLocaleTimeString('nb-NO')
      },
      formatDate (date) {
        if (!date) {
          return null
        }
        let dateObj = new Date(date)
        return dateObj.toLocaleDateString('nb-NO')
      },
      formatFilesize (bytes, decimals = 2) {
        if (bytes === 0) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
      },
      translateAlternatives (type, value) {
        if (value === null || value === undefined) {
          return null
        }
        if (value === true || value === false) {
          value = value.toString()
        } else {
          value = value.toUpperCase()
        }
        return this.$t(type + '.' + value)
      },
      translateBooleans (value) {
        if (value === undefined || value === null) {
          return '-'
        }
        if (value === 'true' || value === true) {
          return this.$t('booleans.true')
        }
        if (value === 'false' || value === false) {
          return this.$t('booleans.false')
        }
        return value
      },
      translateUserRoles (role) {
        if (role === 'contentadministrators') {
          return this.$t('userRoleAreas.contentadministrators')
        }
        if (role === 'productadministrators') {
          return this.$t('userRoleAreas.productadministrators')
        }
        if (role === 'openamadministrators') {
          return this.$t('userRoleAreas.openamadministrators')
        }
        if (role === 'licenseadministrators') {
          return this.$t('userRoleAreas.licenseadministrators')
        }
        if (role === 'useradministrators') {
          return this.$t('userRoleAreas.useradministrators')
        }
        return this.$t('other')
      },
      translateNullValue (value) {
        if (value === undefined || value === null) {
          return '-'
        }
        return value
      },
      isBundleProduct (bundledProducts) {
        if (bundledProducts.length === 0) {
          return this.$t('booleans.false')
        } else {
          return this.$t('booleans.true')
        }
      },
      isLicenseTypeUnEnforced (licenseType) {
        return licenseType !== 'USAGE_RIGHTS_UNENFORCED'
      },
      isUserAsActiveProfile (activeProfile) {
        return (activeProfile !== null && activeProfile.activeProfileType === 'user')
      },
      isOrganizationAsActiveProfile (activeProfile) {
        return (activeProfile !== null && activeProfile.activeProfileType === 'organization')
      },
      formatList (list) {
        if (!list.length) {
          return null
        } else {
          return list.join(', ')
        }
      }
    }
  }
</script>
